module.exports = __webpack_public_path__ + "img/mark_success.49e99d4a.png";